import { UserWorkspaceForFormDTO } from 'features/user/forms/UserPublisherForm/types'
import { CommonSchema } from './common'

export const editSchemaDefault = (userWorkspace: UserWorkspaceForFormDTO): CommonSchema =>
  userWorkspace
